import Footer from "@urbanpiper-engineering/meraki-components/dist/Cells/Footer";
import FooterWebProps from "@urbanpiper-engineering/meraki-components/dist/types/src/Components/Cells/Footer/Web/web.interface";
import React, { useEffect, useState } from "react";
import screenHelper from "../../external/helpers/screenHelper";
import { useRouter } from "next/router";
import configSelector from "../../external/configSelector";

function FooterWrapper(props: FooterWebProps) {
  const router = useRouter();
  const [isCheckoutScreen, setIsCheckoutScreen] = useState(false);
  const hideContactUs = configSelector.getHideContactUs();

  useEffect(() => {
    if (router.pathname) {
      setIsCheckoutScreen(screenHelper.isCheckoutPage(router.pathname));
    }
  }, [router.pathname]);

  if (isCheckoutScreen) {
    return null;
  }

  return (
    <Footer
      contactConfig={props.contactConfig}
      copyRight={props.copyRight}
      moreConfig={props.moreConfig}
      socialConfig={props.socialConfig}
      version={props.version}
      showUrbanPiperBranding={props.showUrbanPiperBranding}
      variant={`default`}
      hideContactUs={hideContactUs}
    />
  );
}

export default FooterWrapper;
